import { ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { WellProductionService } from 'app/modules/well-production-status/services/well-production-status.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Datatable } from 'app/model';
import { first } from 'lodash';
import module from "app/modules/well-production-status/well-production-status.module";

@Component({
  selector: 'app-historical-data-modal',
  templateUrl: './historical-data-modal.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./historical-data-modal.component.scss']
})
export class HistoricalDataModalComponent {
  @ViewChild('pageContainer', { static: true }) pageContainer: ElementRef;
  @ViewChild('ngxDatatable', { static: true }) table: DatatableComponent;
  private subscriptions: Subscription = new Subscription();

  public wellHistoricalRecords$ = this.wellProdService.wellHistoricalRecords$

  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  searchForm: UntypedFormGroup;
  dt: Datatable<any>;

  constructor(
    public dialogRef: MatDialogRef<HistoricalDataModalComponent>,
    @Inject(MAT_DIALOG_DATA) public wellDetails: any,
    public dialog: MatDialog,
    private wellProdService: WellProductionService,
    private cdr: ChangeDetectorRef,
    private _formBuilder: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.getHistoricalProdRecords()

    this.setSearch();
    this.setDataTable();
    this.setPage({ offset: 0 });
  }

  // ngAfterViewInit() {
  //   const width = {
  //     before: this.pageContainer.nativeElement.offsetWidth,
  //     after: 0
  //   }

  //   const dtWidth = interval(500).subscribe(() => {
  //     if (width.before != width.after) {
  //       width.before = width.after;
  //       this.table.recalculate();
  //     }

  //     width.after = this.pageContainer.nativeElement.offsetWidth;
  //   })

  //   this.subscriptions.add(dtWidth);
  // }

  setSearch() {
    this.searchForm = this._formBuilder.group({
      Page: [0],
      PageSize: [10],
      OrderBy: [null],
      OrderDir: [null],
      WellName: [''],
      PlatformName: [''],
      StringName: [''],
      FieldName: [''],
    });

    this.searchForm.get('PageSize').valueChanges.subscribe(value => this.setSize(value));
  }

  setSize(size: number) {
    this.dt.page.size = size;
    this.setPage({ offset: this.dt.page.offset });
  }

  setPage(pageInfo) {
    this.dt.page.offset = pageInfo.offset;
    this.searchForm.patchValue({
      Page: this.dt.page.offset + 1,
    });

    this.wellProdService
      .getHistoricalRecords(this.wellDetails.wellStringId)
      .subscribe((pagedData) => {
        this.dt.page.totalPages = pagedData.data.totalPages;
        this.dt.page.totalRecords = pagedData.data.length//pagedData.data.totalRecords;
        this.dt.rows = pagedData.data;
      });

  }

  getHistoricalProdRecords() {
    this.wellProdService.getHistoricalRecords(this.wellDetails.wellStringId).subscribe()
  }

  setDataTable() {
    this.dt = {
      page: {
        size: this.searchForm.get('PageSize')?.value,
        totalRecords: 0,
        totalPages: 0,
        offset: 0,
      },
      column: {
        mode: ColumnMode.force,
        header: [
          {
            key: 'no',
            name: 'No',
            props: {
              flexGrow: 0.5,
              sortable: false,
              headerClass: ""
            },
          },
          {
            key: 'fieldLongName',
            name: 'Field Name',
            props: {
              flexGrow: 2,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'platformLongName',
            name: 'Platform Name',
            props: {
              flexGrow: 2,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'stringIndicator',
            name: 'String Indicator',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'prodStatus',
            name: 'Production Status',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'lastUpdatedBy',
            name: 'Updated By',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'lastUpdatedDate',
            name: 'Updated Date',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
        ],
      },
      rows: [],
    };
  }

  nextPage() {
    this.filterData.pageNumber = this.filterData.pageNumber + 1
  }

  previousPage() {
    this.filterData.pageNumber = this.filterData.pageNumber - 1
  }

  handleFormatDate(dateString: string, withTime: boolean = true) {
    return handleFormatDate(dateString, withTime)
  }

  onSort(sort: any) {
    if (!sort.sorts.length) return;
    const { dir, prop } = first<any>(sort.sorts);
    this.searchForm.patchValue({
      OrderBy: prop,
      OrderDir: dir,
    });
    this.setPage({ offset: 0 });
  }
}
